if('/cart' === location.pathname) {
  setTimeout(() => {
    BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false)
  }, 800)
}

function fixTDPricePDP(){
  const targetNode = document.querySelector('product-recommendations');
  const observer = new MutationObserver(function(mutationsList, observer) {
      let appliedDisplayRule = BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData);
      BSS_B2B.td.changeCollectionItemVatPriceWithoutCP(BSS_B2B.shopData, appliedDisplayRule);
      observer.disconnect()
  });
  
  const config = { childList: true, subtree: true };
  observer.observe(targetNode, config);  
}

function mutationSearchBar() {
  const targetElement = document.querySelector('predictive-search');
  const observer = new MutationObserver((mutationsList, observer) => {
      for(let mutation of mutationsList) {
          if(mutation.type === 'attributes' && mutation.attributeName === 'open') {
             let appliedDisplayRule = BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData);
              BSS_B2B.td.changeCollectionItemVatPriceWithoutCP(BSS_B2B.shopData, appliedDisplayRule);
          }
      }
  });
  
  const config = { attributes: true };
  observer.observe(targetElement, config);
}

function handlePriceTDCartdrawer(){
  const targetNode = document.getElementById('cart-drawer');
  const observer = new MutationObserver(function(mutationsList, observer) {
      for(let mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            setTimeout(() => {
              let appliedDisplayRule = BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData);
              BSS_B2B.td.changeCollectionItemVatPriceWithoutCP(BSS_B2B.shopData, appliedDisplayRule);
            }, 1000)
            BSS_B2B.makeChangesAfterClickAjaxCart(500)
          }
      }
  });
  const config = { attributes: true };
  observer.observe(targetNode, config);
}

mutationSearchBar();
fixTDPricePDP();
handlePriceTDCartdrawer(); 

const removeATC = () => {    
  const productsCard = document.querySelectorAll(".card--product .card__info-container")
  productsCard.forEach((product) => {
      const ltspMessage = product.querySelector(".bsscommerce-ltsp-message");
      if(ltspMessage) {
           product.querySelector("form[action='/cart/add']").remove();
      }
  })
}

const productInfo = document.querySelectorAll(".product-info__sticky")
productInfo.forEach((product) => {
    const ltspMessage = product.querySelector(".bsscommerce-ltsp-message");
    if(ltspMessage) {
         product.querySelector("product-form form[action='/cart/add']").remove();
    }
})

let hasScrolledToThird = false;

window.addEventListener('scroll', function() {
    const twoThirdsHeight = (1 / 3) * (document.documentElement.scrollHeight - window.innerHeight);
    
    if (!hasScrolledToThird && window.scrollY >= twoThirdsHeight) {

        setTimeout(() => {removeATC();}, 800)
        hasScrolledToThird = true;
    }
});

setTimeout(() => {removeATC();}, 200)